"use strict";exports.__esModule=true;exports.default=void 0;var safeMin=function safeMin(arr,fn){if(arr===void 0){arr=[]}var len=arr.length,i=-1,val,minVal;if(typeof fn==="function"){while(++i<len){val=fn(arr[i],i,arr);if(val!=null&&val<=val){minVal=val;while(++i<len){val=fn(arr[i],i,arr);if(val!=null&&val<minVal){minVal=val}}}}}else{while(++i<len){val=arr[i];if(val!=null&&val<=val){minVal=val;while(++i<len){val=arr[i];if(val!=null&&val<minVal){minVal=val}}}}}return minVal};var _default=safeMin;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/array/safe-min.js
// module id = DOk+
// module chunks = 5